export default __webpack_public_path__ + "static/media/hand_shake_lkw.21110147.png";